<template>
    <div class="bg-white px2-pc px1-mobile pb-1">
        <div class="backlink mt3-pc">
            <a layout="row" layout-align="start center" @click="back"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{ !isNew ? $t('schools.back_sheet') : $t('schools.back')}}</a>
        </div>
        <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb-2 mt3-pc mt1-mobile">{{isNew ? $t('schools.new') : $t('schools.edit')}}</div>

        <v-form class="mt5-pc mt3-mobile" layout="column" layout-align="center center" ref="form" v-model="formValid" @submit.prevent="save">
            <div class="width-95-mobile">
                <v-subheader class="form-subhead">{{$t('schools.info')}}</v-subheader>
                <v-text-field v-model="school.name" :label="$t('schools.name')+' *'" class="field-width" :rules="[ v => !!v || $t('errors.required') ]"></v-text-field>
                <v-select
                    @change="onSectorChange"
                    :label="$t('params.sectors')+' *'"
                    multiple :rules="[ v => (!!v && !!v.length) || $t('errors.required') ]"
                    v-model="school.sectors_ids"
                    :items="sectors"
                    class="field-width"
                >
                </v-select>

                <v-subheader class="form-subhead">{{$t('schools.address')}}</v-subheader>
                <div layout="row" layout-wrap layout-align="start center" class="field-width">
                    <div class="width-250-pc width-100-mobile">
                        <v-text-field v-model="school.zip_code" :label="$t('schools.zip')"></v-text-field>
                    </div>
                    <v-select
                        @change="onCityChange"
                        :label="$t('schools.city')+' *'"
                        :rules="[ v => !!v || $t('errors.required') ]"
                        v-model="school.city_id"
                        :items="$store.state.cities" item-value="id" item-text="label" class="ml3-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="row" layout-wrap layout-align="start center" class="field-width">
                    <div class="width-250-pc width-100-mobile">
                        <v-text-field v-model="school.street_number" :label="$t('schools.number')"></v-text-field>
                    </div>
                    <v-text-field v-model="school.street_name" :label="$t('schools.street')" class="ml3-pc width-100-mobile"></v-text-field>
                </div>
                <v-select
                    v-if="needRD"
                    :label="$t('params.rd')+' *'"
                    :rules="[ v => !!v || $t('errors.required') ]"
                    v-model="school.regional_directorate_id"
                    :items="rds" item-value="id" :item-text="itemLabel" class="full-width"
                >
                </v-select>
                <v-select
                    v-if="needRegion"
                    :label="$t('params.region')+' *'"
                    :rules="[ v => !!v || $t('errors.required') ]"
                    v-model="school.region_id"
                    :items="regions" item-value="id" :item-text="itemName" class="full-width"
                >
                </v-select>
                <v-subheader class="form-subhead">{{$t('schools.contact')}}</v-subheader>
                <v-text-field v-model="school.contact_fullname" :label="$t('schools.fullname')" class="field-width" ></v-text-field>
                <v-text-field v-model="school.contact_email" :label="$t('schools.email')" class="field-width" ></v-text-field>
                <div layout="row" layout-wrap layout-align="start center">
                    <v-text-field v-model="school.contact_phone" :label="$t('schools.phone1')" class="width-100-mobile"></v-text-field>
                    <v-text-field v-model="school.contact_phone2" :label="$t('schools.phone2')" class="ml3-pc width-100-mobile"></v-text-field>
                </div>
                <v-text-field v-model="school.contact_function" :label="$t('schools.function')" class="field-width" ></v-text-field>
            </div>
            <div layout="row" layout-align="end center" class="field-width width-95-mobile">
                <v-btn depressed color="secondary" @click="save" style="text-transform: none">{{$t('_.save')}}</v-btn>
                &nbsp;{{$t('_.or')}}&nbsp;
                <a @click.prevent="back" href="#" class="grey--text">{{$t('_.cancel')}}</a>
            </div>
        </v-form>
    </div>
</template>

<script>
    import Schools from '@/api/schools'
    import Params from '@/api/params'
    import Consts from '@/consts'
    import I18nMixin from '@/mixins/i18n'

    export default {
        mixins: [I18nMixin],
        data () {
            return {
                school: {
                    id: null,
                    sectors_ids: [],
                    name: '',
                    city_id: null,
                    region_id: null,
                    regional_directorate_id: null
                },
                formValid: false,
                loading: false,
                needRD: false,
                needRegion: false,
                regions: [],
                rds: []
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }

            Params.getList('regional-directorates', {is_enabled: 1}).then(res => {
                this.rds = res.data;
            })

            Params.getList('regions', {is_enabled: 1}).then(res => {
                this.regions = res.data;
            })
        },
        methods: {
            fetch () {
                this.loading = true;
                Schools.get(this.$route.params.id).then(res => {
                    this.school = res.data;
                    this.loading = false;
                })
            },
            onCityChange(c){//Si la ville sélectionnée n'a pas de région / DR en fonction du secteur on la demandera
                let key = this.$store.state.cities.map(function(i) { return i.id; }).indexOf(c);
                let city = this.$store.state.cities[key];

                let hasSec = false;
                let hasPrim = false;
                for(let i = 0; i < this.school.sectors_ids.length; i++){
                    const s = this.school.sectors_ids[i];
                    if(s == Consts.PRIMARY){
                        hasPrim = true;
                    }
                    else if(s == Consts.SECONDARY){
                        hasSec = true;
                    }
                }

                if(hasPrim && !city.regional_directorate_id){
                    this.needRD = true;
                } else{
                    this.needRD = false;
                    this.school.regional_directorate_id = null;
                }

                if(hasSec && !city.region_id){
                    this.needRegion = true;
                } else{
                    this.needRegion = false;
                    this.school.region_id = null;
                }
            },
            onSectorChange(){
                if(!this.school.city_id){
                    return;
                }
                let key = this.$store.state.cities.map(function(i) { return i.id; }).indexOf(this.school.city_id);
                let city = this.$store.state.cities[key];

                let hasSec = false;
                let hasPrim = false;
                for(let i = 0; i < this.school.sectors_ids.length; i++){
                    const s = this.school.sectors_ids[i];
                    if(s == Consts.PRIMARY){
                        hasPrim = true;
                    }
                    else if(s == Consts.SECONDARY){
                        hasSec = true;
                    }
                }

                if(hasPrim && !city.regional_directorate_id){
                    this.needRD = true;
                } else{
                    this.needRD = false;
                    this.school.regional_directorate_id = null;
                }

                if(hasSec && !city.region_id){
                    this.needRegion = true;
                } else{
                    this.needRegion = false;
                    this.school.region_id = null;
                }
            },
            itemName(item){
                return this.i18n(item.name);
            },
            itemLabel(item){
                return this.i18n(item.label);
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                if (this.isNew) {
                    Schools.create(this.school).then((res) => {
                        this.$router.push({name: 'admin-schools-show-info', params: {id: res.data.id}});
                        this.$snotify.success(this.$t('schools.created'));
                    })
                } else {
                    Schools.update(this.school.id, this.school).then(() => {
                        this.$router.push({name: 'admin-schools-show-info', params: {id: this.school.id}});
                        this.$snotify.success(this.$t('schools.edited'));
                    })
                }
            },
            back(){
                if(this.isNew){
                    this.$router.push({name: 'admin-schools-index'});
                } else{
                    this.$router.push({name: 'admin-schools-show-info', params: {id: this.school.id}});
                }
            }
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            },
            sectors () {
                return [
                    { value: Consts.PRIMARY, text: this.$t('schools.sector_prim') },
                    { value: Consts.SECONDARY, text: this.$t('schools.sector_sec') },
                    { value: Consts.COMPETENCECENTRE, text: this.$t('schools.sector_comp') },
                ]
            },
        }
    }
</script>